export default __webpack_public_path__ + "static/media/dot-icon.0464bf4c.svg";